import React from 'react';
import PropTypes from 'prop-types';
import './WindowTitleButton.css';

const WindowTitleButton = ({ onClick }) => {
    return (
        <button className="WindowTitleButton" onClick={onClick}>
            <span className="WindowTitleButton-border"></span>
        </button>
    );
};

WindowTitleButton.propTypes = {
    onClick: PropTypes.func
};

export default WindowTitleButton;



// WEBPACK FOOTER //
// ./src/components/Browser/WindowTitleButton.jsx